import React, { PropsWithChildren } from 'react';
import ModalWindow from '@common/components/modal/modal-window';
import ShortcutEditor, { FormData } from './shortcut-editor';

type OwnProps = {
  onClose: () => void;
  form?: string;
  show: boolean;
  onUpdate?: (id: string, updatedShortcut: any) => void;
  onAdd?: (newShortcut: any) => void;
  initialValues?: FormData;
};

const AddFormShortcut = ({
  children,
  onClose,
  onUpdate,
  show,
  onAdd,
  initialValues,
  form
}: PropsWithChildren<OwnProps>) => {
  return (
    <ModalWindow
      trigger={children}
      show={show}
      className="ShortcutForm modal-list"
      size="small"
      onHide={onClose}
    >
      <ShortcutEditor
        form={form}
        onClose={onClose}
        onUpdate={onUpdate}
        onAdd={onAdd}
        initialValues={initialValues}
      />
    </ModalWindow>
  );
};

export default AddFormShortcut;
